import {
  deleteRequest,
  getRequest,
  postRequest,
  putRequest,
} from "../api/request";

export const getPartners = () => {
  return getRequest("/partner");
};

export const createPartner = (partnerData) => {
  return postRequest("/partner", partnerData);
};

export const updatePartner = (id, partnerData) => {
  return putRequest(`/partner/${id}`, partnerData);
};

export const deletPartner = (id) => {
  return deleteRequest(`/partner/${id}`);
};
